/* eslint-disable react/no-array-index-key */
/* eslint-disable operator-linebreak */
import { NavigationItem } from '../desktop-navigation/navigation-item';
import { NavigationMenu } from '../desktop-navigation/navigation-menu';
import { NavigationMenuItem } from '../desktop-navigation/navigation-menu-item';
import { AppNavigationItem, NavigationItemType } from '../types';

export function DesktopNavigationRender({ menuItem }: { menuItem: AppNavigationItem }) {
    if (menuItem === undefined) {
        return null;
    }

    if (menuItem.type !== NavigationItemType.DropdownMenu) {
        return (
            <NavigationItem
                to={menuItem.to}
                label={menuItem.title}
                isExternal={menuItem.type === NavigationItemType.ExternalLink}
            />
        );
    }

    if (menuItem.type === NavigationItemType.DropdownMenu && menuItem.dropdownItems) {
        return (
            <NavigationMenu label={menuItem.title}>
                {menuItem.dropdownItems.map((subMenuItem, index) => (
                    <NavigationMenuItem
                        key={index}
                        to={subMenuItem.to}
                        label={subMenuItem.title}
                        isExternal={subMenuItem.type === NavigationItemType.ExternalLink}
                    />
                ))}
            </NavigationMenu>
        );
    }

    return null;
}
